var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-info"},[_c('div',{staticClass:"left"},[_c('t-title-info',{attrs:{"label":_vm.cNavInfo.english_title,"title":_vm.cNavInfo.title,"iconShow":true,"labelColor":"#000","signRight":false}})],1),_c('div',{staticClass:"right wow fadeInUp"})])
}
var staticRenderFns = []

export { render, staticRenderFns }